import React from 'react';
// import { useLocation, useNavigate } from "react-router-dom";
// Reminder Left Nav component below is really just used on the top nav here now due to code restructure
import AssessmentManagerLeftNav from './AssessmentManagerLeftNav';
// import { appRootPath } from '../utils';

// Rendered inside the dark hub top bar (GoHubTopNav appLogo slot): the two tabs (title hidden below)
export default () => {
  // const navigate = useNavigate();
  // const { pathname } = useLocation();

  // Used by the hidden title below
  // const onHomeClicked = () => {
  //   if (pathname !== `${appRootPath}/assessmentManager`) {
  //     navigate(`${appRootPath}/assessmentManager`);
  //   }
  // }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
    }}>
      {/* Title hidden for now (the tabs alone keep the bar lighter); uncomment to bring it back
      <div 
        style={{
          color: '#ffffff',
          fontSize: '16px',
          fontWeight: 'bold',
          cursor: 'pointer',
          marginRight: '20px',
          whiteSpace: 'nowrap'
        }}
        onClick={onHomeClicked}
      >
        {'Assessment Manager'}
      </div> */}
      <AssessmentManagerLeftNav />
    </div>
  )
}
